import { c as _c } from "react/compiler-runtime";
import type { FieldGroupErrorType, InputType } from '@/app/components/forms/field-group';
import { type CustomFormStyleConfig, getCustomFormStyle, labelRequiredStyled, labelSecondaryTextStyled, labelTextStyled } from '@/app/components/forms/styles';
import type { Theme } from '@/app/types/styles/theme';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface FieldGroupLabelType {
  inputType?: InputType;
  /**
   * Label of field group
   */
  label?: string;
  /**
   * HTML for attribute to support auto focus usability with input id
   */
  htmlFor?: string;
  /**
   * (Optional) Secondary label next to the label of field group
   */
  secondaryLabel?: string;
  /**
   * (Optional) Is this a required field or not?
   */
  required?: boolean;
  /**
   * Default theme styling
   */
  theme?: Theme;
}
interface FieldGroupLabelProps extends FieldGroupLabelType, FieldGroupErrorType {
  /**
   * Custom styling
   */
  customStyle?: CustomFormStyleConfig['fieldGroup'];
}
export const FieldGroupLabel = t0 => {
  const $ = _c(40);
  let customStyle;
  let htmlFor;
  let label;
  let rest;
  let secondaryLabel;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      inputType: t1,
      htmlFor,
      label,
      secondaryLabel,
      required: t2,
      theme: t3,
      customStyle,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = customStyle;
    $[2] = htmlFor;
    $[3] = label;
    $[4] = rest;
    $[5] = secondaryLabel;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    customStyle = $[1];
    htmlFor = $[2];
    label = $[3];
    rest = $[4];
    secondaryLabel = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  const inputType = t1 === undefined ? "input" : t1;
  const required = t2 === undefined ? false : t2;
  const theme = t3 === undefined ? "light" : t3;
  let t4;
  if ($[9] !== customStyle?.label || $[10] !== theme) {
    t4 = cn("text-body-1-fixed font-noto-bold block", labelTextStyled({
      theme
    }), getCustomFormStyle(customStyle?.label));
    $[9] = customStyle?.label;
    $[10] = theme;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const labelClass = t4;
  let t5;
  if ($[12] !== customStyle?.secondary || $[13] !== theme) {
    t5 = cn("ml-1 inline", labelSecondaryTextStyled({
      theme
    }), getCustomFormStyle(customStyle?.secondary));
    $[12] = customStyle?.secondary;
    $[13] = theme;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const secondaryClass = t5;
  let t6;
  if ($[15] !== customStyle?.required || $[16] !== theme) {
    t6 = cn("ml-1 inline", labelRequiredStyled({
      theme
    }), getCustomFormStyle(customStyle?.required));
    $[15] = customStyle?.required;
    $[16] = theme;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const requiredClass = t6;
  const Component = inputType === "control" ? "legend" : "label";
  let t7;
  if ($[18] !== Component || $[19] !== htmlFor) {
    t7 = Component === "label" && {
      htmlFor
    };
    $[18] = Component;
    $[19] = htmlFor;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== Component || $[22] !== htmlFor) {
    t8 = Component === "legend" && !!htmlFor && {
      id: `${htmlFor}-label`
    };
    $[21] = Component;
    $[22] = htmlFor;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "label"
    });
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== secondaryClass || $[26] !== secondaryLabel) {
    t10 = !!secondaryLabel && <span className={secondaryClass} {...createDataAttributes({
      test: "secondary-label"
    })}>{secondaryLabel}</span>;
    $[25] = secondaryClass;
    $[26] = secondaryLabel;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== required || $[29] !== requiredClass) {
    t11 = !!required && <span className={requiredClass} {...createDataAttributes({
      test: "required"
    })}>*</span>;
    $[28] = required;
    $[29] = requiredClass;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== Component || $[32] !== label || $[33] !== labelClass || $[34] !== rest || $[35] !== t10 || $[36] !== t11 || $[37] !== t7 || $[38] !== t8) {
    t12 = <Component {...t7} {...t8} className={labelClass} {...t9} {...rest}>{label}{t10}{t11}</Component>;
    $[31] = Component;
    $[32] = label;
    $[33] = labelClass;
    $[34] = rest;
    $[35] = t10;
    $[36] = t11;
    $[37] = t7;
    $[38] = t8;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};